import { api, errorFn } from "@/common/apiService"
import { paramJoin } from "@/common/utils"

import {
  GENERATE_BANK_REPORT, UPDATE_MARSHAL_REPORT,
  CREATE_BANK,
  CREATE_ROUTE_MARSHAL, UPDATE_ROUTE_MARSHAL, FETCH_MARSHALS,
  DOWNLOAD_MARSHAL_REPORT,
  SCHEDULE_VISIT,
} from '../actions/ptspAdmin';

const state = {
  marshals: [],
  rmReports: [],
};

const getters = {
  getReportById: (state) => (id) => {
    return state.rmReports.find(report => report.id == id)
  },
  getMarshalById: (state) => (id) => {
    return state.marshals.find(marshal => marshal.id == id)
  },
  getObjectById: (state) => (id, storeObjectName) => {
    return state[storeObjectName].find(object => object.id == id)
  }
  // getMerchantById: (state) => (id) => {
  //     return state.merchants.filter((merchant) => merchant.id == id)
  // },

};

const mutations = {
  [CREATE_BANK]: (state, bank) => {
    state.banks.unshift(bank)
  },
  [FETCH_MARSHALS]: (state, marshals) => {
    state.marshals = [...marshals]
  },
  [DOWNLOAD_MARSHAL_REPORT]: (state, reports) => {
    state.rmReports = [...reports]
  },
};

const actions = {
  [GENERATE_BANK_REPORT]: ({ commit, dispatch }, query = {
    date_from: null,
    date_to: null,
    bank: null
  }) => {
    let url = '/bank-report/'

    return api.get(url, {
      responseType: 'blob',
      params: { ...query }
    }).then((resp) => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'bank_report.xls');
      document.body.appendChild(link);
      link.click();
    }).catch(errorFn)
  },
  [DOWNLOAD_MARSHAL_REPORT]: ({ commit }, query={
    rm_id, 
    date_from, 
    date_to,
    report_type: null,
    page: null,
    page_size: null,
  }) => {
    let url = '/rm-reports/'
    return api.get(url, { params: { ...query } }).then((resp) => {
      commit(DOWNLOAD_MARSHAL_REPORT, resp.data)
      return resp.data
    }).catch(errorFn)
  },
  [UPDATE_MARSHAL_REPORT]: async ({ commit, dispatch }, report) => {
    let body = JSON.stringify(report);
    return api.put(`/rm-reports/${report.id}`, body).then((resp) => {
      // user updated
    }).catch(errorFn)
  },
  [CREATE_BANK]: ({ commit, dispatch }, bank) => {
    const body = JSON.stringify(bank);
    return api.post('/banks/', body).then((resp) => {
      commit(CREATE_BANK)
    }).catch(errorFn)
  },
  [FETCH_MARSHALS]: ({ commit }) => {
    return api.get('/users/?user_type=2').then((resp) => {
      commit(FETCH_MARSHALS, resp.data)
    }).catch(errorFn)
  },
  [CREATE_ROUTE_MARSHAL]: ({ commit }, marshal) => {
    const body = JSON.stringify(marshal);
    return api.post(`/api/auth/users/`, body).then((resp) => {
      
    }).catch(errorFn)
  },
  [SCHEDULE_VISIT]: ({ commit, dispatch, rootState }, merchantLocation) => {
    const body = JSON.stringify({
      'emergency_visit': true,
    });
    return api.patch(`/merchant-locations/${merchantLocation.id}/schedule-visit/`, body).then((resp) => {
      // commit(UPDATE_MERCHANT_LOCATION, resp.data)
      // show notification based on resp.data(status)
    }).catch(errorFn)
  },

};

export default {
  state, getters, actions, mutations
}
